const colors = {
    black: '#15171A',
    white: '#FFFFFF', 

    primary: '#0666EB',
    acccent: '#E950A4',

    error: '#F54C3E',
    warning: '#23A423',
    success: '#F7930D',

    grey35: '#525C66',
    grey50: '#828B94',
    grey80: '#C0C6CC',
    grey90: '#DFE2E6',
    grey95: '#EDEEF0',
    grey100: '#F6F7F8',
}

export default colors